import { Directive, EventEmitter, Output } from '@angular/core';
import { MediaSource } from '../../../../models/datamodel/mediasource.model';

@Directive()
export class BaseMediaSourcePanel {
    MediaSource: MediaSource;

    @Output() OnDataChange = new EventEmitter<any>();
    onChange(ev) {
        this.OnDataChange.emit();
    }
}
